import { Link } from "react-router-dom";
import { specialArticles } from "@/data/specials";

const featured = specialArticles.slice(0, 3);

export default function SpecialTeaser() {
  return (
    <section className="relative overflow-hidden border-y border-background-200">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20vintage%20study%20room%20with%20stacked%20books%2C%20a%20typewriter%20and%20warm%20amber%20desk%20lamp%2C%20deep%20wine%20red%20velvet%20curtain%20at%20the%20side%2C%20smoke%20haze%20in%20the%20air%2C%20moody%20cinematic%20composition%2C%20no%20text&width=1920&height=900&seq=sj-special-band&orientation=landscape"
          alt="专题阅读室氛围背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-50/88" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/70 to-background-50/30" />
      </div>

      <div className="container-page relative py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-px w-8 bg-accent-500" />
              <span className="font-label text-xs tracking-[0.28em] text-accent-500">深度专题</span>
            </div>
            <h2 className="mt-3 font-heading text-2xl leading-snug text-foreground-950 md:text-[32px]">
              把那些没说出口的，
              <br className="hidden sm:block" />
              都写在这里
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-700">
              影评、幕后与角色分析三个方向，共六篇长文。不急着下结论，只把镜头里的线索一条条摆出来。
            </p>
            <Link
              to="/special"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              进入专题合辑
              <i className="ri-arrow-right-line text-base leading-none" />
            </Link>
          </div>

          <div className="flex flex-col divide-y divide-background-200 border-y border-background-200">
            {featured.map((article, index) => (
              <Link
                key={article.slug}
                to={`/special/${article.slug}`}
                className="group flex items-start gap-4 py-5"
              >
                <span className="mt-0.5 font-heading text-lg leading-none text-accent-500/70">
                  0{index + 1}
                </span>
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900">
                      {article.group}
                    </span>
                    <span className="font-label text-[11px] text-foreground-500">
                      {article.readTime}阅读
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-base text-foreground-950 transition-colors group-hover:text-accent-400">
                    {article.title}
                  </h3>
                  <p className="mt-1 line-clamp-1 text-xs text-foreground-600">{article.subtitle}</p>
                </div>
                <i className="ri-arrow-right-up-line mt-1 text-lg leading-none text-foreground-500 transition-colors group-hover:text-accent-400" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}